<main class="page-content">
  <div class="pannel-section">
    <!-- OPERACIONES DESTACADAS -->
    <mat-accordion>
      <mat-expansion-panel class="acordion-big" [expanded]="expanded()" (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header #destadas>
          <mat-panel-title class="operaciones">
            {{ 'HOME.OPERACIONES_DESTACADAS' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- @defer (on interaction(destadas)) { -->
        <ng-template matExpansionPanelContent>
          <app-operaciones-destacadas></app-operaciones-destacadas>
        </ng-template>
        <!-- } -->
      </mat-expansion-panel>
    </mat-accordion>

    <!-- ULTIMO STOCK -->
    @if (perfil === this.PERFIL_CLIENTE) {
    <mat-accordion>
      <mat-expansion-panel class="acordion-big" [expanded]="expanded()" (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header #ultimoStock>
          <mat-panel-title class="ultimo-stock">
            {{ 'HOME.ULTIMO_STOCK' | translate }}:
            {{ this.ultimoStockDate | date: 'dd/MM/yyyy' }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-ultimo-stock [lugar]="'home'" (date)="getDateUltimoStock($event)"></app-ultimo-stock>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
    }

    <!-- ULTIMAS PREVISIONES -->

    @if (perfil !== this.PERFIL_PROVEEDOR) {
    <mat-accordion>
      <mat-expansion-panel class="acordion-big" [expanded]="expanded()" (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header #previsiones>
          <mat-panel-title class="previsones">
            {{ 'HOME.ULTIMAS_PREVISIONES' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- @defer (on interaction(previsiones)) { -->
        @if (prevision !== this.PREVISISION_PEDIDO_INTERNO) {
        <ng-template matExpansionPanelContent>
          <app-ultimas-previsiones [centroId]="centroId().id"></app-ultimas-previsiones>
        </ng-template>
        }
        @if (prevision === this.PREVISISION_PEDIDO_INTERNO) {
        <ng-template matExpansionPanelContent>
          <app-ultimas-previsiones-internas [centroId]="centroId().id"></app-ultimas-previsiones-internas>
        </ng-template>
        }
        <!-- } -->
      </mat-expansion-panel>
    </mat-accordion>
    }
  </div>

  <aside class="user-section">
    <div class="title">
      {{ 'HOME.HOLA' | translate }} <span>{{ username }}</span>
    </div>

    @if (notifications().length > 0) { <!--  -->
    <mat-accordion>
      <mat-expansion-panel [expanded]="expanded()" (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header class="header-centro">
          <mat-panel-title>
            <div class="icon-container rojo">
              <!-- <i class="bi bi-bell"></i> -->
              <app-icon color="#fff" strokeColor="#fff" [name]="'notificacion'" [strokeWidth]="5" size="2em">
              </app-icon>
            </div>
            <div class="text">
              <p class="text-title notificaciones-title">{{ 'HOME.NOTIFICACIONES' | translate }}</p>
              <p>
                {{ 'NOTIFICACIONES.MESSAGE' | translate:{ count: notifications().length }:
                (notifications().length === 1 ? 'NOTIFICACIONES.MESSAGE' : 'NOTIFICACIONES.MESSAGE_PLURAL') }}
              </p>

            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="notificaciones">
          @for (notification of notifications(); track $index) {
          <p>{{ notification.mensaje }}</p>
          @if (!$last) {
          <hr>
          }
          }
        </div>

      </mat-expansion-panel>
    </mat-accordion>
    }
    @if (datosGestor()) {

    <mat-accordion>
      <mat-expansion-panel [expanded]="expanded()" (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header class="header-centro">
          <mat-panel-title>
            <div class="icon-container gestor">
              <!-- <img class="icon" [ngSrc]="'icons/fondo-negro/Especialistas Fondo Negro.png'" [fill]="true" width="80%"
                height="80%" alt="Icono Ubicación" /> -->
              <app-icon style="margin-top: 2px;" color="#fff" strokeColor="#fff" [name]="'usuario'" [strokeWidth]="3"
                size="2em">
              </app-icon>
            </div>
            <div class="text">
              <p class="text-title notificaciones-title">{{ 'HOME.GESTOR' | translate }}</p>
              <p>
                {{ datosGestor()?.nombre }}
              </p>

            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="gestor">
          <div class="img-container-icon">
            <img class="icon" [ngSrc]="'icons/fondo-blanco/svg/Telefono2.svg'" width="25" height="25" loading="lazy"
              alt="Teléfono" />
            <p>
              <a href="tel:{{ datosGestor()?.movil }}">{{ datosGestor()?.movil }}</a>
            </p>
          </div>

          <div class="img-container-icon">
            <img class="icon" [ngSrc]="'icons/fondo-blanco/svg/Correo.svg'" width="25" height="25" loading="lazy"
              alt="Correo" />
            <p>
              <a href="mailto:{{ datosGestor()?.email }}">{{ datosGestor()?.email }}</a>
            </p>
          </div>
        </div>


      </mat-expansion-panel>
    </mat-accordion>
    }
    @if (centrosTrabajo.length > 0) {
    <mat-accordion>
      <mat-expansion-panel [expanded]="expanded()" (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header class="header-centro">
          <mat-panel-title>
            <div class="icon-container verde">
              <img [ngSrc]="'icons/fondo-negro/svg/Localización fondo negro 3.svg'" [fill]="true" width="100%"
                height="100%" alt="Icono Ubicación" />
            </div>
            <div class="text">
              <p class="text-title">{{ 'HOME.CENTRO' | translate }}</p>
              <p>{{ centroId().nombre }}</p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-form-field class="centro">
          <mat-select [value]="centroId()" (selectionChange)="onCentroChange($event)">
            @for (centro of centrosTrabajo; track $index) {
            <mat-option [value]="centro">{{ centro.nombre }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-expansion-panel>
    </mat-accordion>
    }



  </aside>
</main>